<template lang="pug">
    section#blockContato
        TextoSimples(:content="textBlock", v-if="textBlock != undefined")
        FormularioContato(:content="formBlock")
</template>

<script>
import { components } from '@/mixins/components'

export default {
    name: "component-block-contato",
    components,
    props: {
        content: {
            type: Object,
            required: true
        },
    },
    computed: {
        textBlock() {
            return this.content.text
        },
        formBlock() {
            return {
                type: this.content.type_form
            }
        },
    },
}
</script>

<style lang="stylus" scoped src="./BlockContato.styl"></style>